import { render, staticRenderFns } from "./SecondModalOpenInPopover.vue?vue&type=template&id=a46c5ab2"
import script from "./SecondModalOpenInPopover.vue?vue&type=script&lang=js"
export * from "./SecondModalOpenInPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports